<!-- ===== Header ===== -->
<div class="card shadow-sm border-0 mb-3">
  <div class="card-body py-3">
    <!-- <h4 class="card-title mb-0 fw-semibold">
      {{ 'MENU.DASHBOARD.categories' | translate }}
    </h4> -->
  </div>

<!-- ===== Form Card ===== -->
<div class="card shadow-sm border-0">
  <div class="card-body">

    <form (ngSubmit)="onSubmit()" enctype="multipart/form-data">

      <div class="row justify-content-center">
        <div class="col-lg-8">

   <!-- Name Arabic -->
<div class="mb-3">
  <label class="form-label fw-medium">
    {{ lang === 'ar' ? 'الاسم بالعربية' : 'Name (AR)' }}
  </label>
  <input
    type="text"
    class="form-control"
    placeholder="{{ lang === 'ar' ? 'الاسم بالعربية' : 'Name (AR)' }}"
    [(ngModel)]="formData.name_ar"
    name="name_ar"
    required
  />
  <small class="text-danger" *ngIf="errors?.name_ar">
    {{ errors.name_ar[0] }}
  </small>
</div>

<!-- Name English -->
<div class="mb-3">
  <label class="form-label fw-medium">
    {{ lang === 'ar' ? 'الاسم بالإنجليزية' : 'Name (EN)' }}
  </label>
  <input
    type="text"
    class="form-control"
    placeholder="{{ lang === 'ar' ? 'الاسم بالإنجليزية' : 'Name (EN)' }}"
    [(ngModel)]="formData.name_en"
    name="name_en"
  />
  <small class="text-danger" *ngIf="errors?.name_en">
    {{ errors.name_en[0] }}
  </small>
</div>

<!-- Description -->
<div class="mb-3">
  <label class="form-label fw-medium">
    {{ lang === 'ar' ? 'الوصف' : 'Description' }}
  </label>
  <textarea
    class="form-control"
    rows="3"
    placeholder="{{ lang === 'ar' ? 'الوصف' : 'Description' }}"
    [(ngModel)]="formData.description"
    name="description"
  ></textarea>
  <small class="text-danger" *ngIf="errors?.description">
    {{ errors.description[0] }}
  </small>
</div>

<!-- Icon -->
<div class="mb-3">
  <label class="form-label fw-medium">
    {{ lang === 'ar' ? 'الأيقونة' : 'Icon' }}
  </label>
  <input
    type="text"
    class="form-control"
    placeholder="{{ lang === 'ar' ? 'الأيقونة' : 'Icon' }}"
    [(ngModel)]="formData.icon"
    name="icon"
  />
  <small class="text-danger" *ngIf="errors?.icon">
    {{ errors.icon[0] }}
  </small>
</div>

<!-- Order -->
<div class="mb-3">
  <label class="form-label fw-medium">
    {{ lang === 'ar' ? 'الترتيب' : 'Order' }}
  </label>
  <input
    type="number"
    min="0"
    class="form-control"
    [(ngModel)]="formData.order"
    name="order"
  />
  <small class="text-danger" *ngIf="errors?.order">
    {{ errors.order[0] }}
  </small>
</div>

<!-- Is Active -->
<div class="mb-3">
  <label class="form-label fw-medium">
    {{ lang === 'ar' ? 'مفعل' : 'Active' }}
  </label>
  <select
    class="form-control"
    [(ngModel)]="formData.is_active"
    name="is_active"
  >
    <option [value]="true">{{ lang === 'ar' ? 'مفعل' : 'Active' }}</option>
    <option [value]="false">{{ lang === 'ar' ? 'غير مفعل' : 'Inactive' }}</option>
  </select>
</div>
          <!-- Submit -->
          <div class="d-flex justify-content-end">
            <button type="submit" class="btn btn-primary px-4">
              {{ 'MENU.DASHBOARD.Add' | translate }}
            </button>
          </div>

        </div>
      </div>

    </form>

  </div></div>

</div>
